import React, { useEffect, useState } from "react";
import Modal from "../../app/UI/Modal/Modal";
import { connect } from "react-redux";
import { withFirestore } from "react-redux-firebase"; 
import { closeModal } from "./modalActions";
import { updateAccount, sendForAuthorization } from "../deposits/depositsActions";
import { ReactComponent as Spinner } from "../../assets/spinner.svg";
import { getFormValues } from 'redux-form';

const AmendDepositModalConfirmation = ({ 
    closeModal, 
    account, 
    transaction,
    profile,
    updateAccount,
    sendForAuthorization,
    firestore,
    formValues,
    closeExpanded
}) => {
    const [merchantName, setMerchantName] = useState("Loading...");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState(null);
    const [requiresProof, setRequiresProof] = useState(false);
    const [daysDifference, setDaysDifference] = useState(0);
    const [hasProofFile, setHasProofFile] = useState(false);

    
    useEffect(() => {
        // Check if proof file exists from form values
        const proofFromForm = formValues && formValues.proof;
        
        
        const proofFromTransaction = transaction && transaction.proof;
        
        setHasProofFile(!!(proofFromForm || proofFromTransaction));
    }, [formValues, transaction]);

    useEffect(() => {
        
        if (transaction && transaction.acceptanceCalendarDateTime) {
            const acceptanceDate = transaction.acceptanceCalendarDateTime.toDate();
            const currentDate = new Date();
            const timeDifference = currentDate - acceptanceDate;
            const days = timeDifference / (1000 * 60 * 60 * 24);
            
            setDaysDifference(days);
            setRequiresProof(days >= 7);
        }
    }, [transaction]);

    useEffect(() => {
        if (account) {
            firestore
                .collection("merchants")
                .doc(account) 
                .get()
                .then(doc => {
                    if (doc.exists) {
                        const merchantData = doc.data();
                        setMerchantName(
                            merchantData && merchantData.name
                              ? merchantData.name
                              : "Unknown Merchant"
                          );
                    } else {
                        setMerchantName("Not available");
                    }
                })
                .catch(error => {
                    console.error("Error fetching merchant:", error);
                    setMerchantName("Error loading");
                });
        }
    }, [account, firestore]);

    const handleConfirm = async () => {
        setIsSubmitting(true);
        setError(null);
        
        try {
            
            if (requiresProof && !hasProofFile) {
                setError("Proof document is required for transactions older than 7 days");
                setIsSubmitting(false);
                return;
            }
            
            
            const proofFile = (formValues && formValues.proof) || (transaction && transaction.proof);
            
            if (proofFile) {
                console.log("Proof found, triggering sendForAuthorization...");
                await sendForAuthorization({
                    account,
                    msgId: transaction.msgId,
                    proof: proofFile, 
                    currentUser: profile.displayName
                }); 
            } else {
                console.log("No proof found, triggering updateAccount...");
                await updateAccount({
                    account,
                    msgId: transaction.msgId,
                    currentUser: profile.displayName
                });
            }
            
            closeModal();
            closeExpanded();
        } catch (err) {
            setError("Failed to amend account. Please try again.");
            console.error("Confirmation error:", err);
            setIsSubmitting(false);
        }
    };

    return (
        <Modal modalHeader="Confirm Account Amendment" onClose={closeModal}>
            <div>
                <p>Are you sure you want to amend the amount for the following account?</p>
                <p><strong>Account ID:</strong> {account}</p>
                <p><strong>Merchant Name:</strong> {merchantName}</p>
                
                {transaction && transaction.acceptanceCalendarDateTime && (
                    <p><strong>Transaction Age:</strong> {Math.floor(daysDifference)} days</p>
                )}
                
                {/* {requiresProof && (
                    <div style={{ marginTop: '10px', padding: '10px', backgroundColor: hasProofFile ? '#d4edda' : '#fff3cd', borderLeft: '4px solid', borderLeftColor: hasProofFile ? '#28a745' : '#ffc107' }}>
                        <p>
                            <strong>{hasProofFile ? 'Proof Document Attached' : 'Note:'}</strong> 
                            {hasProofFile 
                                ? ' Document has been attached to this transaction.'
                                : ' This transaction is over 7 days old and requires supporting proof documentation.'}
                        </p>
                    </div>
                )} */}
                
                {error && (
                    <p style={{ color: 'red', marginTop: '10px' }}>
                        {error}
                    </p>
                )}
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}>
                <button
                    onClick={closeModal}
                    style={{ marginRight: "10px", padding: "10px 20px" }}
                    disabled={isSubmitting}
                >
                    Cancel
                </button>
                <button
                    onClick={handleConfirm}
                    style={{ 
                        padding: "10px 20px", 
                        backgroundColor: isSubmitting ? "#cccccc" : "#007bff", 
                        color: "white", 
                        border: "none",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                    disabled={isSubmitting}
                >
                    {isSubmitting ? (
                        <>
                            <Spinner 
                                style={{
                                    width: "20px",
                                    height: "20px",
                                    marginRight: "10px"
                                }}
                            />
                            Confirming...
                        </>
                    ) : (
                        "Confirm"
                    )}
                </button>
            </div>
        </Modal>
    );
};

const mapStateToProps = (state, ownProps) => {
    const modalProps = ownProps.modalProps || {};
    const stateModalProps = (state.modals && state.modals.modalProps) || {};

    return {
        account: modalProps.account || stateModalProps.account,
        transaction: modalProps.transaction || stateModalProps.transaction,
        profile: state.firebase.profile,
        // Get the current values from the redux-form "filterTransactionsForm"
        formValues: getFormValues('filterTransactionsForm')(state),
        closeExpanded: modalProps.closeExpanded || stateModalProps.closeExpanded
    };
};

const actions = {
    updateAccount,
    sendForAuthorization,
    closeModal
};

export default withFirestore(connect(mapStateToProps, actions)(AmendDepositModalConfirmation));